import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"pb-10 pb-lg-15\"><h2 class=\"fw-bolder d-flex align-items-center text-dark\"> Choose Account Type <i class=\"fas fa-exclamation-circle ms-2 fs-7\" data-bs-toggle=\"tooltip\" title=\"Billing is issued based on your selected account type\"></i></h2><div class=\"text-gray-400 fw-bold fs-6\"> If you need more info, please check out <a href=\"#\" class=\"link-primary fw-bolder\">Help Page</a>. </div></div>", 1)
const _hoisted_3 = { class: "fv-row" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-6" }
const _hoisted_6 = {
  class: "\n              btn btn-outline btn-outline-dashed btn-outline-default\n              p-7\n              d-flex\n              align-items-center\n              mb-10\n            ",
  for: "kt_create_account_form_account_type_personal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createVNode("span", { class: "text-dark fw-bolder d-block fs-4 mb-2" }, " Personal Account "),
  /*#__PURE__*/_createVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "If you need more info, please check it out")
], -1)
const _hoisted_9 = { class: "col-lg-6" }
const _hoisted_10 = {
  class: "\n              btn btn-outline btn-outline-dashed btn-outline-default\n              p-7\n              d-flex\n              align-items-center\n            ",
  for: "kt_create_account_form_account_type_corporate"
}
const _hoisted_11 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createVNode("span", { class: "text-dark fw-bolder d-block fs-4 mb-2" }, "Corporate Account"),
  /*#__PURE__*/_createVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "Create corporate account to mane users")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_Field, {
            type: "radio",
            class: "btn-check",
            name: "accountType",
            value: "personal",
            id: "kt_create_account_form_account_type_personal"
          }),
          _createVNode("label", _hoisted_6, [
            _createVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com005.svg" })
            ]),
            _hoisted_8
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_Field, {
            type: "radio",
            class: "btn-check",
            name: "accountType",
            value: "corporate",
            id: "kt_create_account_form_account_type_corporate"
          }),
          _createVNode("label", _hoisted_10, [
            _createVNode("span", _hoisted_11, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/finance/fin006.svg" })
            ]),
            _hoisted_12
          ])
        ]),
        _createVNode(_component_ErrorMessage, { name: "accountType" })
      ])
    ])
  ]))
}